import { Action, createReducer, on } from '@ngrx/store';
import { fetchDashboardCardsData, fetchDashboardCardsDataFailure, fetchDashboardCardsDataSuccess, fetchDashboardGraphStatsData, fetchDashboardGraphStatsDataFailure, fetchDashboardGraphStatsDataSuccess } from './dashboard.action';


export interface DashboardState {
  data: any[];
  graphStats: any;
  loading: boolean;
  error: any;
}

export const initialState: DashboardState = {
  data: [],
  graphStats: null,
  loading: false,
  error: null,
};

export const DashboardReducer = createReducer(
  initialState,
  on(fetchDashboardCardsData, (state) => {
    return { ...state, loading: true, error: null };
  }),
  on(fetchDashboardCardsDataSuccess, (state, { response }) => {
    return {
      ...state,
      loading: false,
      data: response.result,
    };
  }),
  on(fetchDashboardCardsDataFailure, (state, { error }) => {
    return { ...state, error, loading: false };
  }),
  on(fetchDashboardGraphStatsData, (state) => {
    return { ...state, loading: true, error: null };
  }),
  on(fetchDashboardGraphStatsDataSuccess, (state, { response }) => {
    return {
      ...state,
      loading: false,
      graphStats: response.result,
    };
  }),
  on(fetchDashboardGraphStatsDataFailure, (state, { error }) => {
    return { ...state, error, loading: false };
  }),
);

// Selector
export function reducer(state: DashboardState | undefined, action: Action) {
  return DashboardReducer(state, action);
}
